import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Application } from '@softline/application';
import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-app-list',
  templateUrl: './app-list.component.html',
  styleUrls: ['./app-list.component.scss'],
  imports: [CommonModule, UiCoreModule],
})
export class AppListComponent {
  @Input() application!: Application;
  @Output() navigate = new EventEmitter<Application>();

  goToApplication(application: Application): void {
    this.navigate.emit(application);
  }
}
